import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import usbService from "./usb-services.js";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      primaryLabelSize: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
      primaryName: EncryptUtility.localStorageDecrypt("primaryName"),
      unitIdentifierValid: false,
      unitIdentifier: "",
      disableUnitIdentifier: false,
      showLastTransaction: false,
      lastTransaction: [],
      unitSearchData: [],
      routeTo: "",
      routeToList: [],
      failureCode: "",
      failureCodeList: [],
      showUnitData: false,
      submitValid: false,
      disableFailureCode: true,
      engineeringEvalComments: "",
      disableEngineeringEvalComments: true,
      disableTechComment: true,
      panel: 0,
      disableEcoInfo: true,
      disableCloseEngEval: true,
      disableMSRHistory: true,
      MSRDialog: false,
      MSRData: "",
      EcoInfoDialog: false,
      EcoInfoData: "",
      techCommentsDelDialog: false,
      techCommentsDialog: false,
      techComments: [],
      techMainComments: [],
      showMainComments: false,
      newTechComments: "",
      techCommentsValid: false,
      required: [(v) => !!v || "Field is required"],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  mounted() {},
  methods: {
    //Reset Function
    resetFunction() {
      this.unitIdentifierValid = false;
      this.unitIdentifier = "";
      this.unitSearchData = [];
      this.routeTo = "";
      this.routeToList = [];
      this.failureCode = "";
      this.failureCodeList = [];
      this.showUnitData = false;
      this.submitValid = false;
      this.engineeringEvalComments = "";
      this.disableFailureCode = true;
      this.disableEngineeringEvalComments = true;
      this.disableTechComment = true;
      this.disableEcoInfo = true;
      this.showLastTransaction = false;
      this.lastTransaction = [];
      this.panel = 0;
      this.disableCloseEngEval = true;
      this.disableMSRHistory = true;
      this.disableUnitIdentifier = false;
      this.MSRDialog = false;
      this.MSRData = "";
      this.EcoInfoDialog = false;
      this.EcoInfoData = "";
      this.techCommentsDelDialog = false;
      this.techCommentsDialog = false;
      this.techComments = [];
      this.techMainComments = [];
      this.showMainComments = false;
      this.newTechComments = "";
      this.$refs.unitIdentifierForm.resetValidation();
    },
    //Unit Identifier Search
    async searchUnitIdentifier() {
      let obj = {
        unit: this.unitIdentifier,
        rcvdate: new Date(new Date().getTime() - 86400000).toISOString(),
      };
      let data = await usbService.engineeringEvaluation("post", obj);
      if (data.message !== "NA") {
        this.unitSearchData = data;
        this.showUnitData = true;
        this.disableUnitIdentifier = true;
        this.routeToList = this.unitSearchData?.Result3;
        this.disableTechComment = true;
        this.disableEcoInfo = true;
        this.disableMSRHistory = true;
        this.disableCloseEngEval = true;
        this.showLastTransaction = false; 
        this.lastTransaction = [];
      }
    },
    //Route To Change
    async routeToChange() {
      let obj = {
        proj_code: this.unitSearchData?.Result[0]?.proj_code,
        loc: "A03",
        sbu_key: this.unitSearchData?.Result[0]?.sbu_key,
        atttype: "failcode",
      };
      let data = await usbService.getEnginEvalFaiLCodes("post", obj);
      if (data.message !== "NA") {
        this.failureCodeList = data;
        this.disableFailureCode = false;
      }
    },
    //Tech Comment Click
    async techCommentClick() {
      this.techCommentsDialog = true;
      this.newTechComments = "";
      let data = await usbService.getMainTechComments("get", this.unitSearchData?.Result[0]?.main_id);
      if (data.message !== "NA") {
        this.techMainComments = data;
        this.techComments = [];
        this.showMainComments = true;
      } else {
        this.techMainComments = [];
        this.techComments = [];
        this.showMainComments = true;
      }
    },
    //MSR History
    async msrHistoryClick() {
      let data = await usbService.getMSRCheckList("get", this.unitSearchData?.Result[0]?.main_id);
      if (data.message !== "NA") {
        this.MSRData = data;
        this.MSRDialog = true;
      } else {
        this.MSRData = "";
        this.MSRDialog = true;
      }
    },
    //Close Engineering Evaluation
    closeEngEvalClick() {
      this.techCommentsDelDialog = true;
    },
    //Delete Comments
    async deleteTechComments() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("wc/engi_eval_delete_techcomment?main_key=" + this.unitSearchData?.Result[0]?.main_id)
        .then((response) => {
          if (response.status == 200) {
            this.techCommentsDelDialog = false;
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            this.techCommentsDelDialog = false;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          this.techCommentsDelDialog = false;
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Eco Info
    async ecoInfoClick() {
      let data = await usbService.getEcoInfo("get", this.unitSearchData?.Result[0]?.part_key);
      if (data.message !== "NA" && data?.length !== 0) {
        this.EcoInfoData = data;
        this.EcoInfoDialog = true;
      } else {
        this.EcoInfoData = "";
        this.EcoInfoDialog = true;
      }
    },
    //Close Dialog function
    closeDialog() {
      if (this.MSRDialog) {
        this.MSRData = "";
        this.MSRDialog = false;
      }
      if (this.EcoInfoDialog) {
        this.EcoInfoData = "";
        this.EcoInfoDialog = false;
      }
      if (this.techCommentsDialog) {
        this.techMainComments = [];
        this.newTechComments = "";
        this.showMainComments = false;
        this.techCommentsDialog = false;
      }
    },
    //Submit Tech Comments
    submitTechComments() {
      if (this.$refs.techCommentsForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          main_key: parseInt(this.unitSearchData?.Result[0]?.main_id),
          comments: this.newTechComments,
        };
        this.axios
          .post("/wc/engi_eval_insert_techcomment", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.uploadNewComments();
              this.$refs.techCommentsForm.resetValidation();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    async uploadNewComments() {
      this.newTechComments = "";
      let commentData = await usbService.getTechComments("get", this.unitSearchData?.Result[0]?.main_id);
      if (commentData.message !== "NA") {
        this.techMainComments = [];
        this.techComments = commentData;
        this.showMainComments = false;
      } else {
        this.techMainComments = [];
        this.techComments = [];
        this.showMainComments = false;
      }
    },
    //Engineering Evaluation Submit
    submitEngineeringEvaluation() {
      if (this.$refs.submitForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        // let commentString = this.techComments.map((comment) => comment.strComment.trim()).join(" \r\n ");
        let obj = {
          main_key: parseInt(this.unitSearchData?.Result[0]?.main_id),
          tech_key: parseInt(this.userId),
          destination: this.routeTo,
          comments: this.engineeringEvalComments,
          failc_key: parseInt(this.failureCode),
          lbl_size: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
          printer_type: EncryptUtility.localStorageDecrypt("primaryPrinterType"),
        };
        this.axios
          .post("wc/submit_engineering_evaluation", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              this.resetFunction();
              this.showLastTransaction = true;
              if (data[0]?.Msg !== null && data[0]?.Msg != undefined && data[0]?.Msg != "") {
                this.lastTransaction = data[0]?.Msg;
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
